(function ($, drupalSettings, Drupal) {
  Drupal.behaviors.cbOrganization = {
    attach: function (context, settings) {
      $('.organization-actions button', context).click(function(){
        var t = $(this).data('tab');
        $('.cb-tab').hide();
        $('.organization-actions').hide();
        $(t).fadeIn('slow');
      });
    }
  };
})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal) {
  Drupal.behaviors.strokeToggle = {
    attach: function (context, settings) {
      $('.js-card-stroke-toggle', context).click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $c = $(this).closest('.card');
        $c.toggleClass('card-toggle-open');
      });
    }
  };
})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.cardAdminList = {
		attach: function (context) {
			$('.card-admin-list__messages', context).click(function (e) {
				e.preventDefault();
				var $c = $(this).closest('.card');
				$c.toggleClass('js-chat-active');
				if ($c.hasClass('js-chat-active')) {
					$c.next('.card-admin-list__chat').slideDown(Drupal.eta);
					// When open, do a request to mark the conversation as read.
					var link = $(this);
          $.ajax({
            url: $(this).attr('href'),
            data: {},
            method: 'GET',
            success: function (res) {
              link.find('.unread').remove();
            }
          });
				}
				else {
					$c.next('.card-admin-list__chat').slideUp(Drupal.eta);
				}
			});

			var classes = [
				'card-chat--first-message',
				'card-chat--middle-message',
				'card-chat--last-message',
			];

			var $cards = $('.card-admin-list__chat .card', context);
			// When the comments are posted by ajax, the context is lower than the card itself.
			if ($cards.length == 0) {
				$cards = $(context).closest('.card-admin-list__chat').find('.card');
			}

			// // For the artist conversation page.
			if ($('[id^="user-group-connector-job-con-field-job-conversation"]').length > 0) {
				var $cards = $('[id^="user-group-connector-job-con-field-job-conversation"] .card');
			}

			$cards.each(function () {
				for (var c in classes) {
					$(this).removeClass(classes[c]);
				}

				var org = 'comment-organization';

				var $prev = $(this).prev();
				var $cur = $(this);
				var $next = $(this).next();

				var prevId = $prev.data('comment-user-id');
				var curId = $cur.data('comment-user-id');
				var nextId = $next.data('comment-user-id');

				var isFirst = curId != prevId;
				var isMiddle = curId == prevId && curId == nextId;
				var isLast = curId != nextId;

				if ($cur.hasClass(org)) {
					isFirst = $cur.hasClass(org) && !$prev.hasClass(org);
					isMiddle = $cur.hasClass(org) && $prev.hasClass(org) && $next.hasClass(org);
					isLast = $cur.hasClass(org) && !$next.hasClass(org);
				}

				if (isFirst) {
					$cur.addClass(classes[0]);
				}
				if (isLast) {
					$cur.addClass(classes[2]);
				}
				if (isMiddle) {
					$cur.addClass(classes[1]);
				}

        if ($('.path-cb-organizationopportunity-conversation').length > 0) {
          if ($cur.hasClass(org)) {
            $(this).addClass('card-chat--partner');
            }
          }
        else {
          if (curId != drupalSettings.user.uid && !$cur.hasClass(org)) {
            $(this).addClass('card-chat--partner');
          }
        }
      });
    }
  };
})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal, once) {
  Drupal.behaviors.profileModuleExpandedOnLoad = {
    attach: function (context, settings) {
      const hash = "#block-edityourprofileengagersonly";
      const elements = $(once('profileModuleExpandedOnLoad', hash, context));
      elements.each(function () {
        if (
          window.location.hash &&
          window.location.hash.substring() === hash
        ) {
          const uid = window.location.pathname.split("/").pop();
          const target = "#js-modify-wrapper-" + uid;
          $(target, context).addClass("edit-mode");
        }
      });
      $('#block-step123blockengager .button').click(function() {
        var href = $(this).attr('href');
        if(href.search(hash)) {
          const uid = window.location.pathname.split("/").pop();
          const target = "#js-modify-wrapper-" + uid;
          $(target, context).addClass("edit-mode");
        }
      });
    },
  };

  Drupal.behaviors.profileModuleEmptyToggle = {
    attach: function (context, settings) {
      const elements = $(once('profileModuleEmptyToggle', '.card-profile-module__footer', context));
      elements.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $c = $(this).closest(".card");
        var $cPar = $c.closest(".card-profile-empty");
        Drupal.toggleEmpty($cPar);
      });
    },
  };

  Drupal.behaviors.profileModuleFilledToggle = {
    attach: function (context, settings) {
      var el = ".card-profile-module-filled";
      var toggle = $(el + " .js-card-toggle");
      $(toggle)
        .unbind("click")
        .on("click", function () {
          //doesn't include unfilled cards
          var $c = $(this).closest(".card");
          if (
            $c.parent().hasClass("card-profile-empty__header") &&
            !$c
              .parent()
              .closest(".card-profile-empty")
              .hasClass("card-profile-empty--filled")
          ) {
            var $cPar = $c.closest(".card-profile-empty");
            Drupal.toggleEmpty($cPar);
          } else {
            $c.toggleClass("edit-mode");
            if ($c.hasClass("edit-mode")) {
              $(el + "__toggle-visible", $c)
                .show()
                .slideFadeOut(Drupal.eta);
              $(el + "__toggle-hidden", $c)
                .hide()
                .slideFadeIn(Drupal.eta);
            } else {
              $(el + "__toggle-visible", $c)
                .hide()
                .slideFadeIn(Drupal.eta);
              $(el + "__toggle-hidden", $c)
                .show()
                .slideFadeOut(Drupal.eta);

              // Reset the tabs when hiding.
              $(".organization-actions").show();
              $(".cb-tab").hide();
            }
          }
        });

      // Open the user box by default if the profile is not completed.
      var profileCompleted =
        $(".progress-bar-container .help-button").length === 0;
      if (!profileCompleted) {
        const userBoxOpenButton = '.card-profile-module-filled--type-profile .card-profile-module-filled__ribbon .edit-button';
        const elements = $(once('open-user-box-on-load', userBoxOpenButton));
        elements.each(function () {        
          $(this).click();
        });
      }
    },
  };

  Drupal.toggleEmpty = function ($card) {
    $card.toggleClass("js-empty-open");
    if ($card.hasClass("js-empty-open")) {
      $(".card-profile-empty__header", $card).hide().slideFadeIn(Drupal.eta);
      $(".card-profile-empty__footer", $card).show().slideFadeOut(Drupal.eta);
    } else {
      $(".card-profile-empty__header", $card).show().slideFadeOut(Drupal.eta);
      $(".card-profile-empty__footer", $card).hide().slideFadeIn(Drupal.eta);

      // Reset the tabs when hiding.
      $(".organization-actions").show();
      $(".cb-tab").hide();
    }
  };
  Drupal.behaviors.toggleJoinOrganizationForms = {
    attach: function (context, settings) {
      if ($(".join-organization-block")) {
        $(
          ".join-organization-block .add-org, .join-organization-block .join-org"
        ).click(function (e) {
          $(
            ".card-profile-module-filled__ribbon__actions .close-button"
          ).show();
          $(".org-listing-block-title, .org-listing-block-content").hide();
        });
        $(".join-organization-block .close-button").click(function (e) {
          $(".tab-add-organization, .tab-join-organization").hide();
          $(
            ".org-listing-block-title, .org-listing-block-content, .organization-actions"
          ).fadeIn();
          $(
            ".card-profile-module-filled__ribbon__actions .close-button"
          ).hide();
        });
      }
    },
  };
})(jQuery, drupalSettings, Drupal, once);

(function ($, drupalSettings, Drupal) {

})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal, once) {
  Drupal.behaviors.cbToggle = {
    attach: function (context) {
      const elements = $(once('cbToggle', '.cb-toggle-trigger', context));
      elements.on('click', function () {
        var $row = $(this).closest('.cb-toggle');
        var $cont = $('.cb-toggle-content', $row);
        $row.toggleClass('js-open');
        if ($row.hasClass('js-open')) {
          $cont.hide().slideDown(Drupal.eta, function () {
            $(this).removeAttr('style');
          });
        }
        else {
          $cont.show().slideUp(Drupal.eta, function () {
            $(this).removeAttr('style');
          });
        }
      });

      // Open by default if they have the cb-toggle--open-by-default class.
      $('.cb-toggle', context).each(function () {
        if ($(this).hasClass('cb-toggle--open-by-default')) {
          // Remove the class to avoid another click as a security measure.
          $(this).removeClass('cb-toggle--open-by-default');
          $(this).find('.cb-toggle-trigger').click();
        }
      });

      $('.progress-bar-container', context).click(function (e) {
        e.stopPropagation();
      });

      $('.layout--2col-section .layout__region:first .progress-bar-container', context).each(function () {
        var $item = $(this).clone();
        var $spot = $(this).closest('.cb-toggle').find('.cb-toggle-trigger__copy__toggle-open');
        $spot.append($item);
        $(this).remove();
      });
      $('.close-button.cancel-button').click(function (e) {
        e.preventDefault();
      });
    }
  };

  Drupal.behaviors.tooltipster = {
    attach: function (context) {
      var toggles = $('.tooltipster', context)

      toggles.each(function () {
        var options = {
          side: 'bottom',
          trigger: 'hover',
          interactive: true,
          functionReady: function (instance, helper) {
            var selector = $(helper.origin).data('tooltip-content');
            $(selector).attr('aria-hidden', false);
          },
          functionAfter: function (instance, helper) {
            var selector = $(helper.origin).data('tooltip-content');
            $(selector).attr('aria-hidden', true);
          }
        };
        if ($(this).data('tooltip-color')) {
          options.theme = $(this).data('tooltip-color');
        }

        $(this).tooltipster(options);
        var tooltipster_element = $(this);

        tooltipster_element
          .focus(function () {
            $(this).tooltipster('open');
          })
          .blur(function () {
            $(this).tooltipster('close');
          })
          .click(function (e) {
            e.stopPropagation();
          });

        var tooltip = tooltipster_element.tooltipster('instance');
        tooltipster_element.on("focusin", function () {
          if (!tooltip.status().open)
            tooltip.open();
        });
        tooltip.on('close',
          function (event) {
            if (tooltipster_element.is(':focus') || tooltipster_element.has(':focus').length)
              event.stop();
          }
        );

        // Check if an anchor to this element is in the URL. If it is the case, give the focus.
        var hash = window.location.hash.substr(1);
        if (hash === $(this).attr('id')) {
          // CHeck that it is not in a toggle, otherwise open it.
          var toggle = $(this).closest('.cb-toggle');
          if (toggle.length > 0) {
            var help = $(this);
            // We do a setimeout because the user box will open and change the height of the page.
            setTimeout(function(){
              toggle.find('.cb-toggle-trigger').click();
              $([document.documentElement, document.body]).animate({
                scrollTop: toggle.offset().top
              }, 2000, function() {
                help.focus();
              });
            }, 2000);
          }
          else {
            $(this).focus();
          }
        }
      });
    }
  };

  Drupal.behaviors.accessibility = {
    attach: function (context) {
      // Fake click when pressing enter for accessibility.
      document.onkeydown = function (e) {
        if (e.keyCode === 13) { // The Enter/Return key
          document.activeElement.click();
        }
      };
    }
  };

  Drupal.behaviors.targetClick = {
    attach: function (context) {
      const elements = $(once('target-click-once', '.js-target', context));
      elements.each(function () {
        $(this).on('click', function () {
          var destination = $($(this).data('destination'));
          var action = $(this).data('action');
          if (action === 'click') {
            destination.click();
          }
        });
      });
    }
  };

  Drupal.behaviors.passwordStrong = {
    attach: function (context) {
      var passwordForms = $('.change-pwd-form', context);
      passwordForms.each(function () {
        var form = $(this);

        // Disable the form.
        form.find('input[type="submit"]').each(function () {
          $(this).attr('disabled', 'disabled');
        });
        // Check that the password is not that strong already.
        checkValidPassword(form);

        // Listen to changes.
        var password_fields = form.find('#edit-pass input[type="password"]');
        password_fields.each(function () {
          $(this).on('keyup change', function (e) {
            checkValidPassword(form);
          });
        });
      });
    }
  };

  function checkValidPassword(form) {
    var password_fields = form.find('#edit-pass input[type="password"]');
    var strong = true;
    strong = strong && checkStrongPassword($(password_fields[0]).val());

    generateStrengthIndicator($(password_fields[0]));

    var match_indicator = form.find('.password-confirm .ok');
    var match = match_indicator.length !== 0;
    if (strong && match) {
      form.find('input[type="submit"]').each(function () {
        $(this).removeAttr('disabled');
      });
    }
    else {
      form.find('input[type="submit"]').each(function () {
        $(this).attr('disabled', 'disabled');
      });
    }
  }

  function generateStrengthIndicator(password_input) {
    var indicator_message = '';
    var hasContainer = password_input.next().hasClass('password-indicator');
    // Create the message container.
    if (password_input.val() !== '') {
      if (!hasContainer) {
        $('<div class="password-indicator"></div>').insertAfter(password_input);
      }
      var indicator = password_input.next();
      indicator_message = 'Password strength:';
      if (checkStrongPassword(password_input.val())) {
        indicator_message += ' <strong class="ok">Good</strong>';
      }
      else {
        indicator_message += ' <strong class="error">Weak</strong>';
        indicator_message += '<br/><br/><span class="description">Your password should be at least 8 characters.<br/>Weak passwords are not accepted.</span>';
      }
      indicator.html(indicator_message);
    }
    else {
      password_input.next().remove();
    }
  }

  function checkStrongPassword(string) {
    return string.length >= 8;
  }

  Drupal.behaviors.cbMissingFields = {
    attach: function (context) {
      var missingFields = $('.js-missing-field', context)

      missingFields.each(function () {
        $(this).on('click', function (event) {
          event.preventDefault();
          var destination = $(this).data('selector');
          var card = $(destination).hasClass('card-profile-module-filled') || $(destination).hasClass('card-profile-empty') ? $(destination) : $(destination).closest('.card-profile-module-filled, .card-profile-empty');
          if (card.length > 0 && !card.hasClass('edit-mode')) {
            var edit = card.hasClass('card-profile-module-filled') ? card.find('.card-profile-module-filled__ribbon__actions .edit-button') : card.find('.card-profile-module__footer .edit-button');
            edit.click();
          }
          $("html, body").animate({ scrollTop: card.offset().top }, 500);
          card.focus();
        });
      });
    }
  };

  Drupal.behaviors.cbToggleAddArtist = {
    attach: function (context) {
      // Open the first toggle item by default.
      var artists = $('.card-artist-op', context);
      artists.each(function () {
        var toggles = $(this).find('.cb-toggle');
        if (toggles.length > 0) {
          //unlike other places, where we replaced jquery-once with once, this 
          //seems like a place where 'once' wasn't even needed?   
          //$(toggles[0]).once().find('.cb-toggle-trigger').click();
          $(toggles[0]).find('.cb-toggle-trigger').click();
        }
      });
    }
  };

  Drupal.behaviors.cbAddImage = {
    attach: function (context) {
      var submitButton = $('.cb-profile-module-photos-form input[name="op"]');

      if ($('.cb-profile-module-photos-form a.entity-browser-handle').length > 0) {
        $(submitButton).attr('disabled', false);
      }

      $('.cb-profile-module-photos-form').on('click', 'a.entity-browser-handle', function (e) {
        $(submitButton).attr('disabled', true);
      });
    }
  };

  Drupal.behaviors.cbSlider = {
    attach: function (context) {
      var sliders = $('.cb-slider', context);
      sliders.each(function () {
        var block = $(this).closest('.cb-slider-block');
        var auto_param = Boolean(Number(block.data('auto')));
        var transition_param = block.data('transition');
        var duration_param = Number(block.data('duration'));
        var pause_time_param = Number(block.data('pause_time'));
        var controls_param = Boolean(Number(block.data('controls')));
        var pager_param = Boolean(Number(block.data('pager')));
        $(this).bxSlider({
          pager: false,
          wrapperClass: 'cb-bx-wrapper bx-wrapper',
          prevText: '<i class="icon icon-chevron-left"></i>',
          nextText: '<i class="icon icon-chevron-right"></i>',
          auto: auto_param,
          mode: transition_param,
          speed: duration_param,
          pause: pause_time_param,
          pager: pager_param,
          controls: controls_param,
          touchEnabled: false,
          onSlideAfter: function (currentSlide, totalSlides, currentSlideHtmlObject) {
            var slide = $(currentSlide).find('.paragraph--type--slide');
            var darkMode = slide.hasClass('dark-mode');
            var slider = $(currentSlide).closest('.cb-bx-wrapper');
            enableDarkMode(slider, darkMode);
          },
          onSliderLoad: function (currentIndex) {
            var slider = $(this).closest('.cb-bx-wrapper');
            var slide = $(this).find('div[aria-hidden="false"]');
            var darkMode = slide.find('.dark-mode').length > 0;
            enableDarkMode(slider, darkMode);
          }
        });
      });
    }
  };

  function enableDarkMode(slider, darkMode) {
    var controls = slider.find('.bx-controls-direction');
    if (darkMode) {
      controls.removeClass('light-mode');
      controls.addClass('dark-mode');
    }
    else {
      controls.removeClass('dark-mode');
      controls.addClass('light-mode');
    }
  }

  Drupal.behaviors.cbCharity = {
    attach: function (context) {
      // Clear the field when it is non profit.
      const elements = $(once('cb-charity-once', '#edit-non-profit', context));
      elements.on('change', function () {
        $('#edit-charity-number').val('');
      });
    }
  };

})(jQuery, drupalSettings, Drupal, once);

(function ($, drupalSettings, Drupal) {

  Drupal.behaviors.cbConditions = {
    attach: function (context) {

      var conditions = $('#edit-conditions', context);
      
      var form = conditions.parents('form');

      // Disable submit.
// @fixme Disable this code because of accessibility issue.
//      var submit = form.find('#edit-submit');
//      submit.attr("disabled", true);
//      var checkbox = form.find('#edit-legal-accept');
//      checkbox.attr("disabled", true);
//
//      // Listen the scroll of the conditions.
//      conditions.bind('scroll touchmove', function() {
//        var element = $(this)[0];
//        if(element.scrollHeight - element.scrollTop === element.clientHeight) {
//          checkbox.attr("disabled", false);
//        }
//      });
//
//      checkbox.change(function(){
//        if ($(this).is(':checked')) {
//          submit.attr("disabled", false);
//        }
//        else {
//          submit.attr("disabled", true);
//        }
//      });
    }
  };

})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal, once) {
  /**
   * The Entity Browser module introduce an iframe after clicking on the
   * "Add item" button, that's why we need a MutationObserver on the field
   * an another one on the iframe added. When the ifram is added for the first
   * time we set its height, and when the iframe content change we recalculate it.
   *
   * Check link below for more information about MutationObserver:
   * https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
   */
  Drupal.behaviors.cbEntityBrowserSetHeight = {
    attach: function (context) {
      const elements = $(once('cbEntityBrowserSetHeight', '.entity-browser-iframe-container', context));
      elements.each(function () {
        const target = this;

        // Callback function to execute when mutations are observed
        const callback = function (mutationsList, observer) {
          for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
              const iframes = target.querySelectorAll("iframe");

              if (typeof iframes[0] !== "undefined") {
                const iframeTarget = iframes[0];

                iframeTarget.onload = () => {
                  iframeTarget.classList.add(
                    "js-cb-entity-browser-set-height"
                  );
                  iframeTarget.style.height =
                    iframeTarget.contentWindow.document.body.offsetHeight +
                    "px";
                  // Stop parent observer, I don't think we longer need it after the iframe is loaded
                  observer.disconnect();

                  const config = {
                    attributes: false,
                    childList: true,
                    subtree: true,
                  };

                  // Callback function to execute when mutations are observed inside the iframe
                  const iframeHeightAdjustment = function (mutationsList) {
                    for (const mutation of mutationsList) {
                      if (mutation.type === "childList") {
                        iframeTarget.style.height =
                          iframeTarget.contentWindow.document.body
                            .offsetHeight + "px";
                      }
                    }
                  };

                  const iframeObserver = new MutationObserver(
                    iframeHeightAdjustment
                  );
                  iframeObserver.observe(
                    iframeTarget.contentWindow.document.body,
                    config
                  );
                };
              }
            }
          }
        };
        // Create an observer instance linked to the callback function
        const fieldObserver = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        fieldObserver.observe(target, { attributes: false, childList: true });
        // Later, you can stop observing
        // observer.disconnect();
      });
    },
  };
})(jQuery, drupalSettings, Drupal, once);

(function ($, drupalSettings, Drupal, once) {
  Drupal.behaviors.profileMenu = {
    attach: function (context, settings) {
      const elements = $(once('profile-menu-once', '.nav-dropdown > a', context));
      elements.on('click', function (e) {
        e.preventDefault();
        var $ul = $(this).closest('.nav-dropdown');
        $('body').toggleClass('js-topbar-menu-open');
        if ($('body').hasClass('js-topbar-menu-open')) {
          $('.dropdown-menu', $ul).fadeIn(Drupal.eta);
        }
        else {
          $('.dropdown-menu', $ul).fadeOut(Drupal.eta);
        }
      });
    }
  };
})(jQuery, drupalSettings, Drupal, once);

// remove all private_message, cb_inbox_search and cb_private_message 
// references, but leave in codebase so they can be re-enabled if needed.  
/*
(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.privateMessageMenu = {
		attach: function (context, settings) {
			$('.private-message-menu a', context).each(function () {
				if ($(this).attr('href') == window.location.pathname) {
					$(this).addClass('js-active');
				}
				else if ($(this).attr('href') == '/last-opportunity-conversation' && window.location.pathname.indexOf('opportunity-conversation') !== -1) {
				  $(this).addClass('js-active');
				}
			})
		}
	};
})(jQuery, drupalSettings, Drupal);
*/

(function ($, drupalSettings, Drupal) {

  Drupal.opportunitiesViewCards = '#block-culturebrew-content .card-artist-op';

  Drupal.behaviors.opportunitiesAddView = {
    attach: function (context) {
      if ($('.path-cb-organizationadd-artists', context).length > 0) {
        var $filters = $('<ul id="content-filters" />');
        $filters.append('<li><h5>Filter these results by:</li>');
        $filters.append('<li><input type="search" placeholder="Filter by tag or name" name="quick-search" /></li>');

        var gAble = [ //Only listable fields
          'discipline',
          'city',
          'province',
          'racial_cultural_identity',
          'gender_identity',
          'sexual_orientation',
          'deaf',
          'disability_identity',
        ];
        var gFields = {};
        for (g in gAble) {
          gFields[gAble[g]] = [];
        }
        $(Drupal.opportunitiesViewCards, context).each(function () {
          var data = $(this).data();
          for (var k in data) {
            var vals = data[k].split('|');
            for (var v in vals) {
              if (gAble.indexOf(k) != -1 && vals[v] != '' && gFields[k].indexOf(vals[v]) == -1 && k != 'discipline') {
                gFields[k].push(vals[v]);
                gFields[k].sort();
              }
              else if (k == 'discipline' && isNaN(vals[v]) && vals[v] != 'markup') {
                var split = vals[v].split(",");
                var i;
                for (i = 0; i < split.length; ++i) {
                  if (gAble.indexOf(k) != -1 && split[i] != '' && gFields[k].indexOf(split[i].trim()) == -1) {
                    gFields[k].push(split[i].trim());
                    gFields[k].sort();
                  }
                }
              }
            }
          }

        });

        var gFieldsOrder = {};
        for (var f in gAble) {
          gFieldsOrder[gAble[f]] = gFields[gAble[f]];
        }
        gFields = gFieldsOrder;

        for (var f in gFields) { //Populate fields with select data
          var $li = $('<li data-group="' + f + '" />');
          var $sel = $('<select name="' + f + '" />');
          $sel.append('<option selected value="*">- Any ' + Drupal.convertDisciplineIdToLabel(f) + ' -</option>');
          for (var o in gFields[f]) {
            $sel.append('<option value="' + gFields[f][o] + '">' + gFields[f][o] + '</option>');
          }

          $wrapper = $('<div class="select-wrapper" />');
          $wrapper.append($sel);
          $li.append($wrapper);
          $filters.append($li);
        }

        $filters.append('<li class="clear"><a href="#" class="button">Clear</a></li>');
        $filters.insertBefore('#add-artists-content');
        Drupal.initSortOpportunitiesAdd();
        Drupal.initSortOpportunitiesSearch();
      }
    }
  }

  Drupal.convertDisciplineIdToLabel = function (id) {
    return id.split('_').join(' ');
  }

  Drupal.initSortOpportunitiesSearch = function () {
    $('[name="quick-search"]').keyup(function (e) {
      var v = String($(this).val()).trim().toLowerCase();
      if (v != '') {
        // Drupal.clearSortOpportunities();
        $(Drupal.opportunitiesViewCards).each(function () {
          if (String($(this).text()).toLowerCase().indexOf(v) == -1) {
            $(this).hide();
          }
          else {
            $(this).show();
          }
        });
      }
      else {
        $(Drupal.opportunitiesViewCards).show();
      }
    });
  };

  Drupal.initSortOpportunitiesAdd = function () {
    var $filt = $('#content-filters');
    $('select', $filt).change(function () {
      $('[name="quick-search"]').val('');
      var data = {};
      var has = false;
      var str = '';
      // this is where we hide stuff that isn't in the filter
      $('#content-filters select:not([disabled])').each(function () {
        var k = $(this).attr('name');
        var v = $(this).val();
        if (v != '*') {
          has = true;
          data[k] = v;
          str += '[data-' + k + '*="' + v + '"]';
        }
      });

      var $cards = $(Drupal.opportunitiesViewCards);
      $cards.show();
      $('.clear', $filt).hide();
      if (has) {
        $('.clear', $filt).show();
        $cards.not(str).hide();
      }

      // Update results number and filters user feedback.
      $results_count = $(Drupal.opportunitiesViewCards + ':not([style="display: none;"])').length;
      var $results = Drupal.formatPlural($results_count, '@count artist', '@count artists', { '@count': $results_count });
      $('.add-artists--results').html($results);

      Drupal.getAppliedFiltersArtists();
    });

    $('.clear', $filt).hide().find('a').click(function (e) {
      e.preventDefault();
      Drupal.clearSortOpportunities();
    });
  };

  Drupal.clearSortOpportunities = function () {
    var $filt = $('#content-filters');
    $(':input [value="*"]', $filt).prop('selected', true).parent().trigger('change');
    $('.clear', $filt).hide();
  }

  Drupal.getAppliedFiltersArtists = function () {
    var $filt = $('#content-filters');
    var selectedFilters = $('option[value!="*"]:selected', $filt);
    var $filtersList = '';
    $(selectedFilters).each(function () {
      $filtersList += ' + ' + $(this).val();
    });
    $('.add-artists--additional-filters').html($filtersList);
  }

})(jQuery, drupalSettings, Drupal);
